import React from 'react';
import './index.scss';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import RelatedDrugs from '../prescription-2/RelatedDrugs';
import Breadcrumb from '../DrugDetails/Breadcrumb';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import SkipTo from '../common/Tag/SkipTo';
import _ from 'lodash';
import { BLOCKS } from '@contentful/rich-text-types';
import FactCheckModal from '../common/FactCheckModal';
import AuthorProfile from '../common/AuthorProfile';
import PublishedDate from '../common/PublishedDate';
const SpanishArticles = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const slug = props.match.params.slug;
  const content = JSON.parse(data.content);
  const items = [
    { to: '/es', label: 'Página principal' },
    { to: `/es/recursos`, label: `Recursos` }
  ];
  const MEDICALLY_REVIEWED_BY = 'Revisada médicamente por';
  const WRITTEN_BY = 'Escrito por';

  const getMetaData = () => {
    return (
      <Helmet>
        <title>{data && data.metaTitle}</title>
        <link rel="canonical" href={`/es/recursos/${slug}`} />
        <meta name="description" content={data && data.metaDescription} />
      </Helmet>
    );
  };

  const renderOptions = links => {
    const entryBlockMap = new Map();

    if (links && !_.isEmpty(links.entries)) {
      for (const entry of links.entries.block) {
        entryBlockMap.set(entry.sys.id, entry);
      }
    }
    const assetBlockMap = new Map();
    if (links && !_.isEmpty(links.assets)) {
      for (const asset of links.assets.block) {
        assetBlockMap.set(asset.sys.id, asset);
      }
    }
    return {
      renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: node => {
          const entry = entryBlockMap.get(node.data.target.sys.id);
          return (
            <span
              dangerouslySetInnerHTML={{
                __html: entry.tableData
              }}
            ></span>
          );
        },
        [BLOCKS.EMBEDDED_ASSET]: node => {
          const asset = assetBlockMap.get(node.data.target.sys.id);
          return <img className="contentImg" src={asset.url} alt="" />;
        }
      }
    };
  };

  const displayAuthorProfile = (
    title = '',
    authorData = {},
    withDiscription = false
  ) => (
    <>
      {authorData?.name && (
        <AuthorProfile
          authorTitle={title}
          authorProfileLink={authorData?.reviewerPageOnSingleCare}
          authorDes={authorData?.title}
          authorName={authorData?.name}
          authorQualifications={authorData?.qualifications}
          authorImg={authorData?.photo}
          description={
            withDiscription
              ? documentToReactComponents(
                  JSON.parse(authorData?.biography || null)
                )
              : ''
          }
          className="userDataInfo"
        />
      )}
    </>
  );

  return (
    <div className="dosageDetailsMain recursosContainer">
      {getMetaData()}
      <section className="homepage-new dosageDetailsContent">
        <section className="contentDescription mobile-section scArticles">
          <Breadcrumb items={items}>
            {items.map(({ to, label }) => (
              <a key={label} href={to}>
                {label}
              </a>
            ))}
            <span>{data.name}</span>
          </Breadcrumb>
          <section className="DescriptionSection mobile-section">
            <SkipTo>
              <h1>{data && data.name} </h1>
            </SkipTo>
            {data && (
              <div className="authorLists topLists">
                <>
                  {!_.isEmpty(data?.medicalReviewer) &&
                    displayAuthorProfile(
                      MEDICALLY_REVIEWED_BY,
                      data?.medicalReviewer,
                      false
                    )}
                  {!_.isEmpty(data?.author) &&
                    displayAuthorProfile(WRITTEN_BY, data?.author, false)}
                </>
              </div>
            )}
            <PublishedDate
              publishedAt={data?.publishedAt}
              updatedAt={data?.lastUpdatedDate}
              publishedAtTitle="Publicado"
              updatedAtTitle="Actualizado"
            >
              {(data?.medicalReviewer || data?.author) && <FactCheckModal />}
            </PublishedDate>
            <div>
              {documentToReactComponents(
                content.json,
                renderOptions(content.links)
              )}
            </div>
            <section className="bottomUserDataInfo bottomInfo">
              {data && (
                <div className="authorLists">
                  <>
                    {!_.isEmpty(data?.medicalReviewer) &&
                      displayAuthorProfile(
                        MEDICALLY_REVIEWED_BY,
                        data?.medicalReviewer,
                        true
                      )}
                    {!_.isEmpty(data?.author) &&
                      displayAuthorProfile(WRITTEN_BY, data?.author, true)}
                  </>
                </div>
              )}
            </section>
            <section id="related-drugs" className="relatedDrugs mobile-section">
              {!_.isEmpty(data && data.relatedDrugs) && (
                <RelatedDrugs
                  relatedDrugs={data && data.relatedDrugs}
                  isWhatIs={false}
                  isFromCms={true}
                />
              )}
            </section>
            {!_.isEmpty(data && data.relatedSpanishArticles) && (
              <section
                id="related-drugs"
                className="relatedDrugs mobile-section"
              >
                <section className="top-drugs">
                  <article>
                    <h4 className="top-drugs-heading">{`Recursos Relacionados`}</h4>
                    <ul>
                      {data &&
                        data.relatedSpanishArticles.map((item, id) => {
                          return (
                            <li key={id}>
                              <a href={`/es/recursos/${item.slug}`}>
                                {item.name}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  </article>
                </section>
              </section>
            )}
          </section>
        </section>
      </section>
    </div>
  );
};

export default withRouter(SpanishArticles);
